import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  type CharterInventoryManagementParams,
  type CharterInventoryManagementUpdatePayload,
  fetchCharterInventoryManagement,
  updateCharterInventoryManagement,
} from '~/services/CharterService';

import { charterInventoryManagementQueryKeys } from './charterInventoryManagementQueryKeys';

export function useGetCharterInventoryManagement(params: CharterInventoryManagementParams | null) {
  return useQuery({
    queryKey: params
      ? charterInventoryManagementQueryKeys.list(params)
      : [...charterInventoryManagementQueryKeys.all, 'disabled'],
    queryFn: async ({ signal }) => {
      if (!params) {
        return null;
      }
      return fetchCharterInventoryManagement(params, { signal });
    },
    enabled: Boolean(params),
    refetchOnWindowFocus: false,
  });
}

export function useUpdateCharterInventoryManagement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CharterInventoryManagementUpdatePayload) => updateCharterInventoryManagement(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: charterInventoryManagementQueryKeys.all });
    },
  });
}
